export default {
    namespaced: true,
    state: {
        routeList: [],
        menuData: [],
        toCloseTab: {
            pagePath: "" // 将要关闭的页面对应的path
        },
        toRefreshPage: {
            comName: "" // 需要刷新的页面对应组件名
        },
        keepAliveComponents: [] // 需要keepAlive的组件名
    },
    mutations: {
        setRouterList(state, routeList) {
            state.routeList = [...routeList];
        },
        setMenuData(state, menuData) {
            state.menuData = [...menuData];
        },
        closeTab(state, pagePath) {
            state.toCloseTab = {
                pagePath: pagePath
            };
        },
        refreshPage(state, comName) {
            state.toRefreshPage = {
                comName: comName
            };
        },
        addToKeepAlive(state, comName) {
            // console.log("添加前", JSON.stringify(state.keepAliveComponents));
            !state.keepAliveComponents.includes(comName) &&
                state.keepAliveComponents.push(comName);
            // console.log("添后", JSON.stringify(state.keepAliveComponents));
        },
        removeFromKeepAlive(state, playload) {
            let comName = playload.comName;
            // console.log("去之前", JSON.stringify(state.keepAliveComponents));
            const index = state.keepAliveComponents.indexOf(comName);
            index !== -1 && state.keepAliveComponents.splice(index, 1);
            // console.log("变化来源：", playload.from, JSON.stringify(state.keepAliveComponents));
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/router.js